/*
https://splidejs.com/guides/getting-started/
*/

import '@splidejs/splide/css/core';
import Splide from '@splidejs/splide';

const slider = document.querySelector('.home-nose .splide');

if( slider ) {
    var splide = new Splide(slider, {
        type: 'loop',
        rewind: true,
        speed: 1000,
        arrows: true,
        pagination: false,
        perPage: 3,
        perMove: 1,
        gap: '16px',
        arrowPath: 'M8.354,0,0,8.353l8.354,8.354L9.06,16,1.915,8.853H16.707v-1H1.915L9.06.706Z',
        breakpoints: {
            960: {
                perPage: 1
            },
        }
    });
    splide.mount();
}